
// src/helpers/combine-hoc.js

import React from 'react'
import shallowEqual from './shallow-equal'
import reduceRight from 'lodash/reduceRight'
import filter from 'lodash/filter'

export default function () {
  var outer_args = arguments

  return function(Component) {
    /*
    var displayName = Component.name
    class LoggerComponent extends React.Component {
      UNSAFE_componentWillReceiveProps(nextProps) {
        var { ui, ...otherProps } = this.props
        var { ui, ...nextOtherProps } = nextProps
        if (!shallowEqual(otherProps, nextOtherProps) || !shallowEqual(this.props.ui, nextProps.ui)) {
          var changedKeys = filter(Object.keys(nextProps), (key)=> typeof nextProps[key] != 'function' && key != 'ui' && this.props[key] !== nextProps[key])
          var changedUiKeys = nextProps.ui && filter(Object.keys(nextProps.ui), (key)=> typeof nextProps.ui[key] != 'function' && this.props.ui[key] !== nextProps.ui[key]) || []
          if (changedKeys.length > 0 || changedUiKeys.length > 0)
            global.nativeLoggingHook(`${displayName} changed props:${changedKeys.join(',')} changed ui props:${changedUiKeys.join(',')}`, 1)
        }
      }

      render() {
        return <Component {...this.props} />
      }
    }

    return reduceRight(outer_args, (result, func)=> {
      return func(result)
    }, LoggerComponent)
    */

    return reduceRight(outer_args, (result, func)=> {
      return func(result)
    }, Component)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/combine-hoc.js